import "./privacyPolicy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserShield,
  faLock,
  faCreditCard,
  faEnvelopeOpenText,
} from "@fortawesome/free-solid-svg-icons";

export default function PrivacyPolicy() {
  return (
    <main className="privacyPage">
      <div className="privacyContainer">
        <h1><FontAwesomeIcon icon={faUserShield} className="privacyIconLarge" /> Privacy Policy</h1>

        <div className="privacyIntro">
          <p>We respect your privacy.</p>
        </div>

        <div className="privacyCard">
          <div className="privacyHeader">
            <FontAwesomeIcon icon={faLock} className="privacyIcon" />
            <h2>Information We Collect</h2>
          </div>
          <p>
            Any personal information collected during checkout — including name,
            email, phone number, and address — is used solely for order processing
            and customer communication.
          </p>
        </div>

        <div className="privacyCard">
          <div className="privacyHeader">
            <FontAwesomeIcon icon={faUserShield} className="privacyIcon" />
            <h2>Data Protection</h2>
          </div>
          <p>
            We do not sell or share your information with third parties.
          </p>
        </div>

        <div className="privacyCard">
          <div className="privacyHeader">
            <FontAwesomeIcon icon={faCreditCard} className="privacyIcon" />
            <h2>Secure Payments</h2>
          </div>
          <p>
            Payment details are securely processed through trusted payment gateways.
          </p>
        </div>

        <div className="privacyCard support">
          <div className="privacyHeader">
            <FontAwesomeIcon icon={faEnvelopeOpenText} className="privacyIcon" />
            <h2>Contact Us</h2>
          </div>
          <p>
            For questions regarding your data, contact us directly.
          </p>
        </div>

      </div>
    </main>
  );
}